import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Label } from '../../components/ui/label';
import { Switch } from '../../components/ui/switch';
import { toast } from '../../hooks/use-toast';
import { errorMessage } from '../errors';
import { notificationPrefsApi } from '../notificationPrefsApi';

// One switch per bell event a user may mute. Each seat sets its own.
export default function BellPrefsSection() {
  const [types, setTypes] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    notificationPrefsApi.getBellPrefs()
      .then((d) => setTypes(d.types))
      .catch((e) => toast({ title: 'Could not load bell settings', description: errorMessage(e) }));
  }, []);

  const flip = async (event_type, label, enabled) => {
    const muted = types.filter((t) => (t.event_type === event_type ? !enabled : !t.enabled)).map((t) => t.event_type);
    setSaving(true);
    try {
      const saved = await notificationPrefsApi.setBellPrefs(muted);
      setTypes(saved.types);
      toast({ title: `${label}: bell ${enabled ? 'on' : 'off'}` });
    } catch (e) {
      toast({ title: 'Could not save bell settings', description: errorMessage(e) });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 max-w-lg space-y-3" data-testid="bell-prefs">
      <div>
        <h2 className="font-serif text-lg font-bold" style={{ color: '#070B5F' }}>Bell notifications</h2>
        <p className="text-sm text-slate-500 mt-1">
          Choose which of these show up in your bell. Task, assignment, text and compliance alerts always do. This is only your own bell.
        </p>
      </div>
      {types === null ? (
        <div className="flex items-center text-slate-400 text-sm" data-testid="bell-prefs-loading">
          <Loader2 className="animate-spin mr-2" size={16} /> Loading...
        </div>
      ) : types.map(({ event_type, label, enabled }) => (
        <div key={event_type} className="flex items-center gap-3">
          <Switch id={`bell-${event_type}`} checked={enabled} onCheckedChange={(c) => flip(event_type, label, c)}
            disabled={saving} data-testid={`bell-${event_type}`} />
          <Label htmlFor={`bell-${event_type}`} className="text-sm">{label}</Label>
        </div>
      ))}
    </div>
  );
}
